// components/AppInvite.js
import React from "react";

export function AppInvite({ onContinue, currentUser }) {
  const isLoggedIn = Boolean(currentUser);

  return (
    <div
      className="flex flex-col items-center justify-center w-full px-5 sm:px-6 text-center gap-6 bg-white dark:bg-neutral-900"
      style={{
        minHeight: "100dvh",
        paddingTop: "env(safe-area-inset-top, 24px)",
        paddingBottom: "env(safe-area-inset-bottom, 24px)",
      }}
    >
      {/* App icon */}
      <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-2xl sm:rounded-3xl bg-green-500 flex items-center justify-center shadow-lg shadow-green-500/30">
        <span className="text-white text-4xl sm:text-5xl font-bold select-none">M</span>
      </div>

      {/* Headline */}
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold text-neutral-900 dark:text-white">Welcome to Metisel</h1>
        <p className="mt-2 text-neutral-500 dark:text-neutral-400 text-sm sm:text-base max-w-xs mx-auto leading-relaxed">
          {isLoggedIn
            ? `You're already signed in as @${currentUser?.chatInfo?.[0]?.userName || "you"}. Tap below to open the app.`
            : "Connect, share, and discover — join the community today."}
        </p>
      </div>

      {/* Feature list */}
      {!isLoggedIn && (
        <ul className="text-left space-y-3 w-full max-w-xs">
          {[
            { icon: "💬", text: "Chat privately with friends" },
            { icon: "📰", text: "Follow a live social feed" },
            { icon: "🔁", text: "Share posts and reactions" },
            { icon: "🌍", text: "Connect with people nearby" },
          ].map(({ icon, text }) => (
            <li key={text} className="flex items-center gap-3 text-sm sm:text-base text-neutral-700 dark:text-neutral-300">
              <span className="text-xl sm:text-2xl shrink-0">{icon}</span>
              <span>{text}</span>
            </li>
          ))}
        </ul>
      )}

      {/* CTA */}
      {isLoggedIn ? (
        <button
          onClick={onContinue}
          className="w-full max-w-xs py-3.5 sm:py-3 rounded-full bg-green-500 hover:bg-green-600 active:bg-green-700 text-white font-semibold text-base shadow touch-manipulation transition-colors"
        >
          Open App
        </button>
      ) : (
        <div className="flex flex-col gap-3 w-full max-w-xs">
          <button
            onClick={onContinue}
            className="w-full py-3.5 sm:py-3 rounded-full bg-green-500 hover:bg-green-600 active:bg-green-700 text-white font-semibold text-base shadow touch-manipulation transition-colors"
          >
            Sign Up / Log In
          </button>
          <p className="text-xs text-neutral-400">By continuing you agree to Metisel's Terms of Service.</p>
        </div>
      )}
    </div>
  );
}

export default AppInvite;